import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TableFilterDropdown } from '@/components/table/table-filter-dropdown';
import { getCoachStates } from '@/lib/api-calls';

export function TeacherStateFilterDropdown({
  selectedValues,
  onChange,
}: {
  selectedValues: string[] | undefined;
  onChange: (values: string[]) => void;
}) {
  const { data, isPending } = useQuery(getCoachStates());

  const options = useMemo(() => {
    // Trimming can collapse distinct raw values into one, so dedupe afterwards.
    const fromApi = [...new Set((data?.states ?? []).map((state) => state.trim()).filter((state) => state.length > 0))];
    const extraSelected = (selectedValues ?? []).filter((state) => !fromApi.includes(state));
    return [...fromApi, ...extraSelected]
      .sort((a, b) => a.localeCompare(b))
      .map((state) => ({ label: state, value: state }));
  }, [data?.states, selectedValues]);

  return (
    <TableFilterDropdown
      title="State"
      options={options}
      selectedValues={selectedValues ?? []}
      onChange={onChange}
      isLoading={isPending}
    />
  );
}
